import React from "react"

const PhoneBackground = ({ width="22", height="22", viewBox='0 0 22 22' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 0C4.928 0 0 4.928 0 11s4.928 11 11 11 11-4.928 11-11S17.072 0 11 0zm4.277 13.007l.007-.066.075.036c.2.096.33.16.384.265.06.118.06.628-.145 1.243-.2.616-1.161 1.165-1.623 1.245-.415.064-.94.092-1.514-.106-2.129-.792-3.293-1.363-5.478-4.462-1.112-1.698-1.44-3.295-.14-4.843.298-.337.637-.344 1.101-.3l.045-.001c.143-.006.322-.014.496.446.088.224.23.596.367.955.175.46.342.896.375.97.06.13.101.274.02.457-.189.388-.386.624-.533.8-.202.242-.31.37-.173.626.141.262.621 1.112 1.336 1.806a6.121 6.121 0 001.776 1.218c.066.031.12.056.159.078.24.118.38.105.52-.066.274-.34.457-.596.591-.783.33-.459.36-.502.711-.361.22.086 1.4.712 1.643.843z"
        fill="#fff"
      />
    </svg>
  )
}

export default PhoneBackground